export const NOT_AT_ALL = 1
export const PROBABLY_NOT = 2
export const NEUTRAL = 3
export const LIKELY = 4
export const EXTREMELY_LIKELY = 5
export const EMAIL_TEMPLATE_EMPTY_VALUE = 'None'

export const surveyStrings = {
  [NOT_AT_ALL]: 'hm.constants.survey_answers.not_at_all',
  [PROBABLY_NOT]: 'hm.constants.survey_answers.probably_not',
  [NEUTRAL]: 'hm.constants.survey_answers.neutral',
  [LIKELY]: 'hm.constants.survey_answers.likely',
  [EXTREMELY_LIKELY]: 'hm.constants.survey_answers.extremely_likely'
}

export const surveyValues = {
  [NOT_AT_ALL]: 'Not at all likely',
  [PROBABLY_NOT]: 'Probably not likely',
  [NEUTRAL]: 'Neutral',
  [LIKELY]: 'Likely',
  [EXTREMELY_LIKELY]: 'Extremely likely'
}

// reverse mapping of surveyValues
export const surveyStringToValues = {}
Object.keys(surveyValues).forEach((k) => (surveyStringToValues[surveyValues[k]] = k))

export const OFFERING_PLANS = {
  ASSESS: 'assess',
  MONITOR: 'monitor',
  PROTECT: 'protect',
  INTELLIGENCE: 'intelligence'
}

export const ASSESS_UI_STATES = {
  INTEGRATION: 'integration',
  INGESTING: 'ingesting',
  PREVIEW: 'preview',
  ASSESSED: 'assessed'
}

export const VISION2_MENU_ITEM_DASHBOARD = 'Dashboard'
export const VISION2_MENU_ITEM_RISK_ANALYSIS = 'Risk Analysis'
export const VISION2_MENU_ITEM_RISK_DETECTION_RULES = 'Risk Detection Rules'
export const VISION2_MENU_ITEM_ELEVATE_RESPONSE_ENGINE = 'Risk Response Rules'
export const VISION2_MENU_ITEM_ACTION_LOGS = 'Action Logs'
export const VISION2_MENU_ITEM_AUDIT_LOGS = 'Audit Logs'
export const VISION2_MENU_ITEM_SECURITY_SUMMARY = 'Security Summary'
export const VISION2_MENU_ITEM_KEY_INSIGHTS = 'Key Insights'
export const VISION2_MENU_ITEM_REPEAT_PERFORMERS = 'Repeat Performers'
export const VISION2_MENU_ITEM_RISKIEST_GROUPS = 'Riskiest Groups'
export const VISION2_MENU_ITEM_MANAGER_DASHBOARD = 'Manager Dashboard'

export const API_ERROR_DETAIL_MIN_HEIGHT = 50

export const DELETE_MODAL_INITIAL_DATA = {
  isOpen: false,
  name: '',
  id: ''
}

export const INBOUND_INTEGRATION_DESCRIPTION =
  'By clicking "Start Integration" you authorize Elevate Security to start pulling data periodically.'
export const OUTBOUND_INTEGRATION_DESCRIPTION =
  'By clicking "Start Integration" you authorize Elevate Security to transmit data to, and receive data from, the application specified.'
export const REFLEX = 'reflex'
export const CHECKOUT_VISION_STEP = 'checkoutVisionStep'
